// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDRpw42kwdwV-D1ePmJ6cFFaxno4aeqQl8",
    authDomain: "hga-team6-react.firebaseapp.com",
    projectId: "hga-team6-react",
    storageBucket: "hga-team6-react.appspot.com",
    messagingSenderId: "42209771942",
    appId: "1:42209771942:web:fde984bde623088f20cf67"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { auth, firestore };